const oracleSandboxConfig = {
  fhirVersion: "4.0.1",
  clientId: "e92aa02a-327d-4878-a90a-0e5e721a754f",
  scopes: "launch openid fhirUser patient/*.read encounter/*.read communication/*.read",
  supportsBatch: false,
  welcomeMessage: "Welcome Oracle Health Sandbox!",
  logo: "/images/logos/oracle-healthcare.png",
  iss: "https://fhir-ehr-code.cerner.com/r4/ec2458f2-1e24-41c8-b71b-0e701af7583d" // 🔗 FHIR base URL / issuer
};

export default oracleSandboxConfig;